import { graphql } from '@/generated/gql';

export const COUNTRY_REPORT_DETAIL_QUERY = graphql(/* GraphQL */ `
  query CountryReportDetail($id: UUID!) {
    cataclysm {
      countryReport(id: $id) {
        id
        name
        description
      }
    }
  }
`);
